import { IntegrationKey } from '@erp/rpc';
import { ProductModule } from '@erp/shared-types';
import { useListIntegrations } from 'src/api/rpc/hooks/integrations/useIntegrations';
import { useIsModuleEnabled } from '@/hooks/organization-config/useOrganizationEnabledModules';

/**
 * Whether Famous is integrated for this org — either the Famous Integration
 * module is enabled or the integration is connected; env vars alone do not
 * count. Mirrors the backend's isFamousIntegrationEnabledForOrg. Gates the
 * Famous workflow nodes in the node library and the Famous Health settings
 * section.
 */
export function useFamousWorkflowIntegrationEnabled(): boolean {
  const { isModuleEnabled } = useIsModuleEnabled();
  const { data } = useListIntegrations();

  const moduleEnabled = isModuleEnabled(ProductModule.FAMOUS_INTEGRATION);
  const installed = Boolean(data?.installed?.[IntegrationKey.Famous]);

  return moduleEnabled || installed;
}
